// @flow
import React from 'react';

import {LOCATIONS, THEMES, SIZES} from './constants';
import type {State, Dispatch} from './state';
import Dropdown from './Dropdown';

type Props = {|
  state: State,
  dispatch: Dispatch,
|};

export const LocationConfig = ({state, dispatch}: Props) => {
  const handleLocationChange = (e) => {
    if (e !== state.location) {
      dispatch({kind: 'LOCATION_CHANGED', location: e});
    }
  };
  return (
    <Dropdown
      label="Customer location"
      onChange={handleLocationChange}
      value={state.location}
      optionMap={LOCATIONS}
    />
  );
};

export const ThemeConfig = ({state, dispatch}: Props) => {
  const handleThemeChange = (e) => {
    if (e !== state.theme) {
      dispatch({kind: 'THEME_CHANGED', theme: e});
    }
  };

  return (
    <Dropdown
      label="Theme"
      onChange={handleThemeChange}
      value={state.theme}
      optionMap={THEMES}
    />
  );
};

export const SizeConfig = ({state, dispatch}: Props) => {
  const handleSizeChange = (e) => {
    if (e !== state.size) {
      dispatch({kind: 'SIZE_CHANGED', size: e});
    }
  };
  return (
    <Dropdown
      label="Size"
      onChange={handleSizeChange}
      value={state.size}
      optionMap={SIZES}
    />
  );
};
